export default "__VITE_ASSET__T6sVMFE0__"